import { createAction } from 'typesafe-actions';

export const tetrisGlobalActions = {
  showHelpModal: createAction('tetrisGlobal/SHOW_HELP_MODAL')<boolean>(),
  playVideo: createAction('tetrisGlobal/PLAY_VIDEO')<string>(),
  miniPlayer: createAction('tetrisGlobal/VIDEO_MINI_PLAYER')<boolean>(),
};
